import apiClient from "../../utils/apiClient";

const API_URL = "/admin/payments";

export async function getAllPayments() {
  const response = await apiClient.get(API_URL);
  return response.data;
}
